// @ts-ignore
import state from '../state.ts'

export default function addsSourcePage() {
    state.currentPage.value = window.location.pathname;
}